import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import merch from 'assets/json/merchandise.json'
// import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { BigNumber } from "ethers";
// import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { Router } from '@angular/router'
// import { SimpleGlobal } from 'ngx-simple-global'
import { UserService } from 'app/services/user/user.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { environment } from 'environments/environment';
import { NFTItemService } from 'app/services/contract/contracts-services/nft-item.service';
import { NFTv2Service } from 'app/services/contract/contracts-services/nft.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { MapGeocoder } from '@angular/google-maps';
import { first } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from 'app/services/spinner/spinner.service';
import { ContractsService } from 'app/services/contract/contracts.service';

@Component({
  selector: 'app-merchandise',
  templateUrl: './merchandise.component.html',
  styleUrls: ['./merchandise.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MerchandiseComponent implements OnInit {
  // public account
  public kryptomonsV2
  public merchandise
  public parsedKryptomon
  public parsingIndex
  public parsedSuccess
  public selectedMerch: any = []
  public selectedColor
  public selectedImageBase
  public selectedKryptomonImage
  public selectedKryptomonId
  public selectedQuantity
  public selectedSize
  public cartArray: any = []
  public cartObject: any = []
  public fullName
  public address
  public city
  public stateProvince
  public country
  public postalCode
  public options: any = {}
  public showAddressForm
  public streetNumber
  public kmonPrice
  public custiomizableKind
  public merchandiseBackup
  public hasKmonAllowance
  public taxNumber
  public isLoading
  public isSuccess
  public phone
  public SearchCountryField /* = SearchCountryField */;
  public CountryISO /* = CountryISO */;
  public PhoneNumberFormat /* = PhoneNumberFormat */;
  public kmonBalanceFull
  public notEnoughKmon
  public deliveryPrice
  public reloadSession
  public isJunior
  public selectedKryptomon
  public isBabyImage
  wallet: string;

  merchandiseForm: FormGroup

  constructor(
    private router: Router,
    private http: HttpClient,
    // private sg: SimpleGlobal,
    private userService: UserService,
    private tokenService: TokenService,
    private web3Service: Web3Service,
    private nftItemService: NFTItemService,
    private nftv2Service: NFTv2Service,
    private toastService: ToastService,
    private fb: FormBuilder,
    private spinnerService: SpinnerService,
    private contractsService: ContractsService

  ) {
    this.merchandise = merch;
    this.merchandiseBackup = merch;
    this.parsedSuccess = false;
    this.kryptomonsV2 = []
    this.parsedKryptomon = []
    this.isJunior = false;
    this.isBabyImage = false;
    //this.selectedColor = "def"
    this.selectedQuantity = 1;
    this.cartObject.cartArray = [];
    //arezoo
    this.showAddressForm = false;
    this.selectedMerch.colors = []
    this.selectedMerch.sizes = []
    console.log(this.merchandise)
    this.selectedColor = "black";
    this.selectedSize = "def";
    this.custiomizableKind = {};
    this.selectMerch(0);
    this.isLoading = false;
    //arezoo
    this.isSuccess = false;
    this.cartObject.totalPrice = 0;
    this.cartObject.totalUSD = 0;

    //this.checkSizes()
    this.wallet = this.userService._userInfoData.recordedWallet;
    // if (this.getCookieValue("user-email") == '') {
    //   //location.reload();
    //   this.router.navigate(['/login'])
    // } else {
    // if (this.appComponent.accounts == undefined) {
    //   this.appComponent.accountsObservable.subscribe((item: any) => {
    //     this.wallet = item[0];
    //     this.getKryptomons();
    //     this.getKmonValue()
    //     this.checkAllowance()
    //     this.getKmonBalance();
    //     setInterval(() => {
    //       this.checkSession()
    //     }, 5000)
    //     setInterval(() => {
    //       this.getKmonValue()
    //     }, 600000)

    //   });
    // } else {
    // this.wallet = this.appComponent.accounts[0];

    //initialize form
    this.merchandiseForm = this.fb.group({
      fullName: this.fb.control('', [Validators.required]),
      address: this.fb.control('', [Validators.required]),
      streetNumber: this.fb.control('', [Validators.required]),
      city: this.fb.control('', [Validators.required]),
      stateProvince: this.fb.control('', [Validators.required]),
      country: this.fb.control('', [Validators.required]),
      postalCode: this.fb.control('', [Validators.required]),
      phone: this.fb.control('', [Validators.required, Validators.minLength(8)]),
      taxNumber: this.fb.control('', []),
    });


    this.getKryptomons();
    this.getKmonValue()
    this.checkAllowance()
    this.getKmonBalance();
    setInterval(() => {
      this.checkSession()
    }, 5000)
    setInterval(() => {
      this.getKmonValue()
    }, 600000)
    // }
    // }
  }

  ngOnInit(): void {
  }

  checkSession() {
    // if (this.getCookieValue("user-email") == '' || this.getCookieValue("user-email") == undefined || this.getCookieValue("user-email") == null) {
    //   this.reloadSession = true;
    // } else {
    //   this.reloadSession = false;
    // }
  }

  // gotoLogin() {
  //   this.router.navigate(['/login'])
  // }

  async getKmonBalance() {
    const balance = await this.tokenService.contract.methods.balanceOf(this.wallet).call();
    this.kmonBalanceFull = parseFloat(await this.web3Service.getWeb3().utils.fromWei(balance));
    setTimeout(() => {
      this.getKmonBalance();
    }, 300000)
  }

  async checkAllowance() {
    let allowance = await this.tokenService.contract.methods.allowance(this.wallet, "0x04B0f7d5CB2CE4688497f2525748FB7A9aFFa394").call();
    this.hasKmonAllowance = BigNumber.from(allowance).gt(0);
    console.log(allowance)
  }

  chooseKind(kind) {
    this.custiomizableKind = kind
    if (this.kryptomonsV2.length > 0) {
      if (kind) {
        this.merchandise = this.merchandiseBackup.filter(item => (item.custom == kind && item.title.toLowerCase().indexOf('customized') >= 0));
      } else {
        this.selectedKryptomonId = undefined;
        this.selectedKryptomonImage = undefined;
        this.merchandise = this.merchandiseBackup.filter(item => (item.custom == kind));
      }
    } else {
      if (kind) {
        this.merchandise = this.merchandiseBackup.filter(item => (item.title.toLowerCase().indexOf('var') >= 0));
      } else {
        this.selectedKryptomonId = undefined;
        this.selectedKryptomonImage = undefined;
        this.merchandise = this.merchandiseBackup.filter(item => (item.custom == kind));
      }
    }

  }
  changeQuantity(what) {
    if (what == "plus") {
      this.selectedQuantity++
    } else {
      if (this.selectedQuantity > 0) {
        this.selectedQuantity--
      } else {
        this.selectedQuantity = 0;
      }
    }
  }

  selectMerch(index) {
    this.selectedMerch = this.merchandise[index];
    this.selectedMerch.colors = [];
    this.selectedQuantity = 1;
    for (let key in this.selectedMerch.variations.colors) {
      this.selectedMerch.colors.push(key);
    }
    for (let i = 0; i < this.merchandise.length; i++) {
      if (i == index) {
        this.merchandise[i].selected = true;
      } else {
        this.merchandise[i].selected = false;
      }
    }
    this.selectedColor = this.selectedMerch.colors[0]
    this.checkSizes();
    console.log(this.selectedMerch)
  }

  checkSizes() {
    this.selectedImageBase = this.selectedMerch.variations.colors[this.selectedColor].image
    this.selectedMerch.sizes = [];
    for (let key in this.selectedMerch.variations.colors[this.selectedColor].sizes) {
      this.selectedMerch.sizes.push(key);
    }
    console.log(this.selectedImageBase)
  }

  selectKryptomon(index) {
    console.log(index)
    console.log(this.parsedKryptomon[index])
    this.isBabyImage = false;
    this.selectedKryptomonImage = this.parsedKryptomon[index].data.image
    this.selectedKryptomonId = "#" + this.parsedKryptomon[index].data.tokenId
    this.selectedKryptomon = this.parsedKryptomon[index]
    if (this.parsedKryptomon[index].data.status > 1) {
      this.isJunior = true;
    } else {
      this.isJunior = false;
    }
    for (let i = 0; i < this.parsedKryptomon.length; i++) {
      if (i == index) {
        this.parsedKryptomon[i].selected = true;
      } else {
        this.parsedKryptomon[i].selected = false;
      }
    }
  }

  toggleBaby() {
    setTimeout(() => {
      this.isBabyImage = !this.isBabyImage;
      if (this.isBabyImage) {
        this.selectedKryptomonImage = environment.apiImages + "images/kryptomons/png/kmon_" + this.selectedKryptomon.data.tokenId + "_png.png"
      } else {
        this.selectedKryptomonImage = environment.apiImages + "images/kryptomons-junior/png/kmon_" + this.selectedKryptomon.data.tokenId + "_png.png"
      }
    }, 100)
  }

  async getKryptomons() {
    await this.nftv2Service.contract.methods
      .ownedKryptomons()
      .call({
        from: this.wallet,
      })
      .then((receipt) => {
        console.log(receipt);
        if (receipt.length > 0) {
          for (let i = 0; i < receipt.length; i += 1) {
            //this.getKryptomonsDetails(receipt[i]);
            this.kryptomonsV2.push({ tokenId: receipt[i], isMigrating: false });
          }
          this.parsingIndex = 0;
          this.parseKryptomon(this.parsingIndex, this.kryptomonsV2)
          this.chooseKind(true)
        } else {
          this.chooseKind(false)
        }

        //this.fetchKryptomon = true;

      }).catch((err) => {
        console.log(err, 'err')
        //this.fetchKryptomon = true;
      });
  }

  onlyForOwner() {
    this.toastService.add({
      severity: 'error',
      summary: 'errorMsg.notAvailable',
      detail: 'toastMessage.customForRealKryptomon',
    });
  }

  addToCart() {

    this.cartObject.totalPrice = 0;
    this.cartObject.totalUSD = 0;

    let objectCart: any = {}
    objectCart.title = this.selectedMerch.title
    objectCart.image = this.selectedImageBase
    objectCart.kryptomomImage = this.selectedKryptomonImage
    objectCart.size = this.selectedSize
    objectCart.quantity = this.selectedQuantity;
    objectCart.color = this.selectedColor;
    objectCart.priceUSD = this.selectedMerch.priceUSD * this.selectedQuantity
    objectCart.priceKMON = (Math.round(objectCart.priceUSD / this.kmonPrice * 100)) / 100;
    objectCart.productId = this.selectedMerch.product_id
    objectCart.template_id = this.selectedMerch.template_id
    objectCart.kryptomonId = this.selectedKryptomonId
    objectCart.variation_id = this.selectedMerch.variations.colors[this.selectedColor].sizes[this.selectedSize]
    objectCart.positions = this.selectedMerch.positions
    objectCart.custom = this.selectedMerch.custom
    this.cartArray.push(objectCart)
    this.cartObject.cartArray = this.cartArray;
    //this.cartObject.totalPrice = this.cartObject.totalPrice + objectCart.priceKMON;
    //this.cartObject.totalUSD = this.cartObject.totalUSD + objectCart.priceUSD

    for (let i = 0; i < this.cartArray.length; i++) {
      this.cartObject.totalPrice = this.cartArray[i].priceKMON + this.cartObject.totalPrice;
      this.cartObject.totalUSD = this.cartArray[i].priceUSD + this.cartObject.totalUSD;
    }


    if (this.cartObject.totalUSD >= 50) {
      if (this.deliveryPrice > 0) {
        this.cartObject.totalPrice = this.cartObject.totalPrice - this.deliveryPrice;
      }
      this.deliveryPrice = 0;
    } else {
      this.deliveryPrice = (Math.round(10 / this.kmonPrice * 100)) / 100;
    }


    this.cartObject.totalPrice = this.cartObject.totalPrice + this.deliveryPrice;

    if (this.cartObject.totalPrice > this.kmonBalanceFull) {
      this.notEnoughKmon = true;
    } else {
      this.notEnoughKmon = false;
    }

    console.log(this.cartObject)
    console.log(this.cartObject.totalUSD)
  }

  removeFromCart(index) {

    this.cartObject.totalPrice = 0;
    this.cartObject.totalUSD = 0;
    this.cartArray.splice(index, 1)
    for (let i = 0; i < this.cartArray.length; i++) {
      this.cartObject.totalPrice = this.cartArray[i].priceKMON + this.cartObject.totalPrice;
      this.cartObject.totalUSD = this.cartArray[i].priceUSD + this.cartObject.totalUSD;
    }

    if (this.cartObject.totalUSD >= 50) {
      this.deliveryPrice = 0;
      if (this.deliveryPrice > 0) {
        this.cartObject.totalPrice = this.cartObject.totalPrice - this.deliveryPrice;
      }
    } else {
      this.deliveryPrice = (Math.round(10 / this.kmonPrice * 100)) / 100;
    }
    this.cartObject.totalPrice = this.cartObject.totalPrice + this.deliveryPrice;
    if (this.cartObject.totalPrice > this.kmonBalanceFull) {
      this.notEnoughKmon = true;
    } else {
      this.notEnoughKmon = false;
    }
  }

  openKmonWallet() {
    this.router.navigate(["/wallet"])
  }

  parseKryptomon(index, kryptomonsV2) {
    //console.log(index)
    if (index < kryptomonsV2.length) {
      this.http.get(environment.apiBaseUrlV22 + "kryptomon/" + kryptomonsV2[index].tokenId).subscribe(async (response: any) => {
        let i = index;
        //console.log(i)
        let item = response
        let id = item.tokenId;
        this.http.get(environment.nftServer + "v1/nfts?contractAddress=0x04b0f7d5cb2ce4688497f2525748fb7a9affa394&tokenId=" + id).subscribe((extraMarketData: any) => {
          // item.order = extraMarketData.data[0].order;
          if (item.ranking < 650) {
            item.tierName = "Rookie"
            item.tierNumber = 1
            if (item.ranking < 625) {
              item.starValue = 1
            } else {
              item.starValue = 1.5
            }

          } else if (item.ranking >= 650 && item.ranking < 700) {
            item.tierName = "Veteran"
            item.tierNumber = 2
            if (item.ranking >= 650 && item.ranking < 675) {
              item.starValue = 2
            } else {
              item.starValue = 2.5
            }
          } else if (item.ranking >= 700 && item.ranking < 775) {
            item.tierName = "Elite"
            item.tierNumber = 3
            if (item.ranking >= 700 && item.ranking < 725) {
              item.starValue = 3
            } else if (item.ranking >= 725 && item.ranking < 750) {
              item.starValue = 3.5
            } else {
              item.starValue = 4
            }
          } else {
            item.tierName = "Hero"
            item.tierNumber = 4
            if (item.ranking >= 775 && item.ranking < 800) {
              item.starValue = 4.5
            } else {
              item.starValue = 5
            }
          }

          if (item.status > 1) {
            if (!extraMarketData.data[0].nft.data.kryptomon.breedingCount) {
              item.breedingDone = 0;
            } else {
              item.breedingDone = extraMarketData.data[0].nft.data.kryptomon.breedingCount;
            }

            if (!extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) {
              extraMarketData.data[0].nft.data.kryptomon.breedingsLeft = 0;
            }

            item.breedingTotal = parseInt(extraMarketData.data[0].nft.data.kryptomon.breedingsLeft) + parseInt(item.breedingDone)
          }
          if (item.status == 0) {

            var imageSelected

            if (item.genes.xFactor == 1) {
              imageSelected = "super"
            } else {
              imageSelected = item.speciality.toLowerCase()
            }

            if (item.extraData.unfreezable == 1) {
              item.image = "./assets/img/top_special/" + item.elementType + "/" + imageSelected + ".png";
            } else {
              item.image = "./assets/img/" + item.elementType + "/" + imageSelected + ".png";
            }
          } else if (item.status == 1) {
            item.image = environment.apiImages + "images/kryptomons/png/kmon_" + item.tokenId + "_png.png"
          } else if (item.status == 2) {
            item.image = environment.apiImages + "images/kryptomons-junior/png/kmon_" + item.tokenId + "_png.png"
          }

          if (!item.name) {
            item.name = "#" + item.tokenId
          }
          if (item.genes.sex < 5) {
            item.genderIcon = "./assets/img/Icon/female-icon.svg"
          } else {
            item.genderIcon = "./assets/img/Icon/male-icon.svg"
          }

          item.mainFamilyImage = "./assets/img/icons/" + item.elementType.toLowerCase() + ".svg";
          item.secondaryFamilyImage = "./assets/img/icons/" + item.elementTypeSecond.toLowerCase() + ".svg";

          this.parsedKryptomon.push({ data: item });

          this.parsingIndex++
          this.parseKryptomon(this.parsingIndex, kryptomonsV2)
          this.parsingIndex++
          this.parseKryptomon(this.parsingIndex, kryptomonsV2)
          this.parsingIndex++
          this.parseKryptomon(this.parsingIndex, kryptomonsV2)

        })
      })
    } else if (index / 3 == kryptomonsV2.length) {
      this.parsedSuccess = true;
      console.log(this.parsedKryptomon)
    }
  }

  getGmapsAddress(event: any) {
    this.handleAddressChange(event);
  }

  handleAddressChange(address: any/* Address */) {
    for (let i = 0; i < address.address_components.length; i++) {
      let addressObj = address.address_components[i]
      if (addressObj.types[0] == "street_number") {
        this.merchandiseForm.get('streetNumber').setValue(addressObj.long_name);
      } else if (addressObj.types[0] == "route") {
        this.merchandiseForm.get('address').setValue(addressObj.long_name);
      } else if (addressObj.types[0] == "locality") {
        this.merchandiseForm.get('city').setValue(addressObj.long_name);
      } else if (addressObj.types[0] == "administrative_area_level_2") {
        this.merchandiseForm.get('stateProvince').setValue(addressObj.short_name);
      } else if (addressObj.types[0] == "country") {
        this.merchandiseForm.get('country').setValue(addressObj.short_name);
        if (this.merchandiseForm.get('country').value == 'BR') {
          this.merchandiseForm.controls['taxNumber'].setValidators([Validators.required]);
        } else {
          this.merchandiseForm.controls['taxNumber'].clearValidators();
        }
        this.merchandiseForm.controls['taxNumber'].updateValueAndValidity();
      } else if (addressObj.types[0] == "postal_code") {
        this.merchandiseForm.get('postalCode').setValue(addressObj.short_name);
      }
    }
    // console.log(address.formatted_address)
    // console.log(address.geometry.location.lat())
    // console.log(address.geometry.location.lng())
    // for (let i = 0; i < address.address_components.length; i++) {
    //   let addressObj = address.address_components[i]
    //   if (addressObj.types[0] == "street_number") {
    //     this.streetNumber = addressObj.long_name
    //   } else if (addressObj.types[0] == "route") {
    //     this.address = addressObj.long_name
    //   } else if (addressObj.types[0] == "locality") {
    //     this.city = addressObj.long_name
    //   } else if (addressObj.types[0] == "administrative_area_level_2") {
    //     this.stateProvince = addressObj.short_name
    //   } else if (addressObj.types[0] == "country") {
    //     this.country = addressObj.short_name
    //   } else if (addressObj.types[0] == "postal_code") {
    //     this.postalCode = addressObj.short_name
    //   }
    // }

  }

  checkDeliveryInfos() {
    // let deliveryObject: any = {}
    // deliveryObject.name = this.fullName
    // deliveryObject.address1 = this.address + " " + this.streetNumber
    // deliveryObject.city = this.city
    // deliveryObject.state_code = this.stateProvince
    // deliveryObject.country_code = this.country
    // deliveryObject.zip = this.postalCode
    // deliveryObject.tax_number = this.taxNumber
    // deliveryObject.phone = this.phone/* .e164Number */
    // console.log(deliveryObject);
    // console.log(this.cartArray);
    // console.log(this.phone)
    let purchaseObject: any = {};
    let deliveryObject: any = {
      name: this.merchandiseForm.get('fullName').value,
      address1: this.merchandiseForm.get('address').value + ' ' + this.merchandiseForm.get('streetNumber').value,
      city: this.merchandiseForm.get('city').value,
      state_code: this.merchandiseForm.get('stateProvince').value,
      country_code: this.merchandiseForm.get('country').value,
      zip: this.merchandiseForm.get('postalCode').value,
      tax_number: this.merchandiseForm.get('taxNumber').value,
      phone: this.merchandiseForm.get('phone').value,
    }

    purchaseObject.delivery = deliveryObject;
    purchaseObject.cart = this.cartArray;

    this.executePurchase(purchaseObject);
  }

  async executePurchase(purchaseObject) {
    this.isLoading = true;
    this.spinnerService.setSpinner(true);
    let itemsToPurchase = [];
    let quantitiesToPurchase = [];

    for (let i = 0; i < purchaseObject.cart.length; i++) {
      itemsToPurchase.push(purchaseObject.cart[i].template_id)
      quantitiesToPurchase.push(purchaseObject.cart[i].quantity)
    }

    console.log(itemsToPurchase)
    console.log(quantitiesToPurchase)
    console.log(this.hasKmonAllowance)
    if (this.hasKmonAllowance) {
      await this.nftItemService.contract.methods.createMerchOrder(itemsToPurchase, quantitiesToPurchase).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((item: any) => {
        console.log(item)
        if (item.events.MerchOrderCreated !== undefined) {
          let transaction: any = {}
          transaction.transactionId = item.events.MerchOrderCreated.transactionHash;
          transaction.account = this.wallet
          let orderChain: any = {}
          orderChain.productIds = item.events.MerchOrderCreated.returnValues.productIds
          orderChain.quantities = item.events.MerchOrderCreated.returnValues.qtys
          transaction.orderChain = orderChain;
          let auth: any = {}
          auth.authToken = this.getCookieValue("playfab-entity-token")
          auth.userEmail = this.userService._userInfoData.loginEmail//this.getCookieValue("user-email")
          purchaseObject.auth = auth;
          purchaseObject.transaction = transaction;
          console.log(purchaseObject)
          this.http.post(environment.apiBaseUrl + "merch/createOrder.php", purchaseObject).subscribe((item: any) => {
            console.log(item)
            if (item.status == "done") {
              this.isLoading = false;
              this.spinnerService.setSpinner(false);
              this.isSuccess = true;
              //this.cartArray = []

            } else {
              this.toastService.add({
                severity: 'error',
                summary: 'errorMsg.generic',
                detail: item.error,
              });
              this.isLoading = false;
              this.spinnerService.setSpinner(false);
              this.isSuccess = false;
            }
          }, (err: any) => {
            this.toastService.genericError()
            this.isLoading = false;
            this.spinnerService.setSpinner(false);
            this.isSuccess = false;
          })
        } else {
          this.toastService.genericError()
          this.isLoading = false;
          this.isSuccess = false;
        }
      }, (err: any) => {
        console.log(err)
        this.toastService.genericError()
        this.isLoading = false;
        this.isSuccess = false;
      })
    } else {
      this.tokenService.contract.methods.approve("0x04B0f7d5CB2CE4688497f2525748FB7A9aFFa394", this.web3Service.getWeb3().utils.toWei('999999999999')).send({
        ...this.contractsService.additionalParameters(),
        from: this.wallet
      }).then((result) => {
        console.log(result)
        if (result.events.Approval !== undefined) {
          this.hasKmonAllowance = true;
          this.executePurchase(purchaseObject)
        } else {
          this.isLoading = false;
          this.isSuccess = false;
          this.spinnerService.setSpinner(false);
          this.toastService.genericError()
        }
      }).catch((err) => {
        this.isLoading = false;
        this.spinnerService.setSpinner(false);
        this.isSuccess = false;
        this.toastService.genericError()
        console.log('allowance failed')
      });;
    }
  }

  getKmonValue() {
    this.http.get("https://api.coingecko.com/api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
      console.log(item)
      this.kmonPrice = item.kryptomon.usd;
    })
  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  }

}
